import React from 'react';
import { PublicPlan } from '@wix/ambassador-pricing-plans-v2-plan/types';
import { Plan, PricingVariant } from '@wix/ambassador-pricing-plans-v3-plan/types';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { isPlanV3 } from '@wix/pricing-plans-utils';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { getFreeTrialDaysLabel } from '../../../../../utils';
import { getVariantFreeTrialDaysLabel } from '../../../../../utils/plan-v3-utils';
import { st, classes } from './FreeTrial.st.css';

interface Props {
  plan: PublicPlan | Plan;
  variant: PricingVariant | undefined;
  freeTrialDaysExist: boolean;
  highlighted: boolean;
  className?: string;
}

export const FreeTrial: React.FC<Props> = ({ plan, variant, freeTrialDaysExist, highlighted, className }) => {
  const { t } = useTranslation();

  if (!freeTrialDaysExist) {
    return null;
  }

  const label = isPlanV3(plan) ? getVariantFreeTrialDaysLabel(variant!, t) : getFreeTrialDaysLabel(plan, t);

  return (
    <span data-hook={VIEWER_HOOKS.PLAN_FREE_TRIAL} className={st(classes.duration, { highlighted }, className)}>
      {label}
    </span>
  );
};
